import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getProduct } from "../../actions/product";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
const { RangePicker } = DatePicker;
const { Option } = Select;
class ProductList extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",

    a: null,

    e: null,
    ds: null,
    de: null,
    n: null,
    pr: null,
    p: 1,
    current: 1,
  };
  componentDidMount = async () => {
    const res = await this.props.getProduct(
      this.state.p,
      this.state.e,
      this.state.a,
      this.state.n,
      this.state.pr,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    user_id,
    name,
    email,
    brand_name,
    product_id,
    created_at,
    active,
    thumbnail
  ) => {
    return {
      sl,
      user_id,
      name,
      email,
      brand_name,
      product_id,
      created_at,
      active,
      thumbnail,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getProduct();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (code_id) => {
    history.push(`/code-details?code=${code_id}`);
  };
  handleEditModalVisible = (code_id) => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      id: code_id,
    });
  };
  onClosePass = () => {
    this.setState({
      passVisible: false,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };
  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getProduct(
      page,
      this.state.e,
      this.state.a,
      this.state.n,
      this.state.pr,
      this.state.ds,
      this.state.de
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getProduct(
      this.state.p,
      this.state.e,
      this.state.a,
      this.state.n,
      this.state.pr,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "ID",
        dataIndex: "user_id",
        key: "user_id",
        width: "20%",
        ...this.getColumnSearchProps("user_id"),
      },
      {
        title: "PRODUCT NAME",
        dataIndex: "name",
        key: "name",
        width: "15%",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "EMAIL",
        dataIndex: "email",
        key: "email",
        width: "25%",
        ...this.getColumnSearchProps("email"),
      },
      {
        title: "BRAND NAME",
        dataIndex: "brand_name",
        key: "brand_name",
        width: "20%",
        ...this.getColumnSearchProps("brand_name"),
      },
      {
        title: "PRODUCT ID",
        dataIndex: "product_id",
        key: "product_id",
        width: "15%",
        ...this.getColumnSearchProps("product_id"),
      },
      {
        title: "REGISTAR DATE",
        dataIndex: "created_at",
        key: "created_at",
        width: "20%",
        ...this.getColumnSearchProps("created_at"),
      },

      {
        title: "Status",
        dataIndex: "active",
        key: "active",
        width: "15%",
        ...this.getColumnSearchProps("active"),
      },
      {
        title: "THUMBNAIL",
        dataIndex: "thumbnail",
        key: "thumbnail",
        width: "25%",
      },
    ];
    const { data } = this.state;

    const rows = [
      data?.product
        ? data?.product.map((item, id) =>
            this.createData(
              id + 1,
              item?.client?.user_id,
              item?.name,
              item?.client?.email,
              item?.client?.brand_name,
              item?.product_id,
              this.makeLocalTime(item?.created_at),
              item?.active === "active" ? (
                <Tag color="#bde235">Active</Tag>
              ) : (
                <Tag color="#cf7520">Inactive</Tag>
              ),
              item.thumbnail ? (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/files/${item?.thumbnail}`}
                  width="40px"
                  height="40px"
                  alt=""
                />
              ) : (
                <img src="/noimageav.jpg" width="40px" height="40px" alt="" />
              )
            )
          )
        : "",
    ];

    return (
      <Content>
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Product List</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Product List"
          subTitle="Product Management"
          extra={<Tag color="#2db7f5"> {data?.count} product found</Tag>}
        ></PageHeader>
        <br />
        <Row>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Client Email"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ e: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Product Name"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ n: e.target.value })}
            />
          </Col>
          <br />
          <br />
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Product Id"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ pr: e.target.value })}
            />
          </Col>

          <Col xs={24}>&nbsp;</Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select a status"
              name="status"
              optionFilterProp="children"
              onChange={(e) => this.setState({ a: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>

              <Option value="active">Active</Option>
              <Option value="inactive">Inactive</Option>
            </Select>
          </Col>

          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <RangePicker
              onChange={this.handleDate}
              format="YYYY/MM/DD"
              style={{ width: "80%" }}
            />
            &nbsp; &nbsp;
            <Tooltip title="search" onClick={this.handleApiSearch}>
              <Button type="primary" shape="circle" icon={<SearchOutlined />} />
            </Tooltip>
          </Col>
        </Row>
        <br />

        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          current={this.state.current}
          total={data?.count}
          pageSize="20"
          onChange={this.handlePageChange}
          pageSizeOptions={[20]}
        />
       
      </Content>
    );
  }
}

export default connect(null, { getProduct })(ProductList);
